import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, TrendingUp, Users2, Repeat, TrendingDown } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ron = (n) => `${(n || 0).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RON`;

// Tab „Venituri": calculat din datele deja stocate (plăți + abonamente),
// fără interogare live Stripe pentru sumele istorice.
export function RevenuePanel() {
  const [date, setDate] = useState(null);
  const [eroare, setEroare] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/admin/revenue`, { withCredentials: true })
      .then((r) => setDate(r.data))
      .catch(() => setEroare("Nu am putut încărca veniturile."));
  }, []);

  if (eroare) return <p className="text-center text-rose-500 py-10">{eroare}</p>;
  if (!date) return <Loader2 className="h-6 w-6 animate-spin text-emerald-600 mx-auto mt-10" />;

  return (
    <div className="space-y-3" data-testid="revenue-panel">
      <div className="rounded-2xl brand-bg text-white p-5">
        <p className="text-xs text-white/80">Total încasat (istoric)</p>
        <p data-testid="revenue-total" className="font-heading text-3xl font-black mt-1">{ron(date.totalIncasat)}</p>
      </div>
      <div className="grid grid-cols-2 gap-2.5">
        <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-4">
          <Repeat className="h-4 w-4 text-emerald-500 mb-1.5" />
          <p data-testid="revenue-mrr" className="font-heading text-xl font-black text-slate-900">{ron(date.mrr)}</p>
          <p className="text-[11px] text-slate-400">venit lunar recurent (MRR)</p>
        </div>
        <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-4">
          <Users2 className="h-4 w-4 text-slate-400 mb-1.5" />
          <p className="font-heading text-xl font-black text-slate-900">{date.abonatiLunar + date.abonatiAnual}</p>
          <p className="text-[11px] text-slate-400">abonați activi ({date.abonatiLunar} lunar · {date.abonatiAnual} anual)</p>
        </div>
        <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-4">
          <TrendingUp className="h-4 w-4 text-emerald-500 mb-1.5" />
          <p className="font-heading text-xl font-black text-slate-900">{date.everPaid}</p>
          <p className="text-[11px] text-slate-400">au plătit vreodată</p>
        </div>
        <div className="rounded-2xl bg-white border border-slate-100 shadow-sm p-4">
          <TrendingDown className="h-4 w-4 text-rose-400 mb-1.5" />
          <p data-testid="revenue-churn" className="font-heading text-xl font-black text-slate-900">{date.churnRate}%</p>
          <p className="text-[11px] text-slate-400">rată de anulare (churn)</p>
        </div>
      </div>
    </div>
  );
}
